// Livewire hooks
window.addEventListener("DOMContentLoaded", () => {
    // Livewire.hook('message.sent', (message, component) => {
    //     KTApp.blockPage({
    //         overlayColor: '#000000',
    //         state: 'primary',
    //         message: 'Processing...'
    //     });
    // });
    // Livewire.hook('message.processed', (message, component) => {
    //     KTApp.unblockPage();
    // });
    Livewire.hook('message.failed', (message, component) => {
        KTApp.unblockPage();
        Swal.fire({
            title: 'Oops!',
            text: 'Roundtrip to server failed, your connection might be down.',
            icon: 'error',
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: 'Report Error',
            customClass: {
                confirmButton: 'btn font-weight-bold btn-secondary',
                cancelButton: 'btn font-weight-bold btn-light-primary'
            }
        }).then(function (result) {
            if (result.value) {
                $('#kt_feedback a').trigger('click');
            }
        });
    });
});

/**
 * Issue bootstrap initialization for node
 */
window.addEventListener('issue-bootstrap', event => {
    BasicBootstrap(event.detail.nodezero);
});

/**
 * Issue ckeditor value update
 */
window.addEventListener('update-ckeditor', event => {
    ckEditors[event.detail.instance].setData(event.detail.value);
});

/**
 * Notifier
 */
window.addEventListener('issue-notify', event => {
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": event.detail.delay ?? 5000,
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    // let title = event.detail.title ?? ((event.detail.type ?? 'info') == 'error' ? 'Attention' : 'Notification');
    let title = event.detail.title ?? '';
    let message = event.detail.message ?? 'No Message';

    switch (event.detail.type) {
        case 'info':
            toastr.info(message, title);
            break;
        case 'success':
            toastr.success(message, title);
            break;
        case 'warning':
            toastr.warning(message, title);
            break;
        case 'error':
            toastr.error(message, title);
            break;
        default:
            toastr.info(message, title);
    }

});

/**
 * Scroll
 */
window.addEventListener('scroll-to', event => {
    if (event.detail.position == 'top') {
        scrollTo({ top: 0, left: 0, behavior: event.detail.behavior ?? "smooth" });
    } else if (event.detail.position == 'bottom') {
        scrollTo({ top: document.body.scrollHeight, left: 0, behavior: event.detail.behavior ?? "smooth" });
    }
});

/**
 * Modal
 */
window.addEventListener('show-modal', event => {
    $("#mDialog_" + event.detail.diagId).on("shown.bs.modal", function () {
        KTApp.unblockPage();
        BasicBootstrap("#mDialog_" + event.detail.diagId);
        $("#mDialog_" + event.detail.diagId + " :input:visible:enabled:not([readonly]):eq(1)").focus();
    }).modal("show");
    // console.log('open from listener '+event.detail.diagId);
});
window.addEventListener('close-modal', event => {
    $("#mDialog_" + event.detail.diagId).on("hidden.bs.modal", function () {
        eval(event.detail.onclosed);
    }).modal("hide");
    // console.log('close from listener '+event.detail.diagId)
});